import {Component, OnInit, Input} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import {Feed} from '../../models/feed';
import {Comment} from '../../models/comment';
import {FeedService} from '../../services/feed.service';
import {AuthService} from '../../services/auth.service';
import filestack from 'filestack-js';

import { ModalFeedComponent } from './modal-feed/modal-feed.component';
import { ModalContentComponent } from './modal-content/modal-content.component';

declare var $: any;
import Swal from 'sweetalert2';

const apikey = 'A7zJTtgFRW6cWqHglvjIgz';
const client = filestack.init(apikey);

@Component({
  selector: 'app-clientes-feed',
  templateUrl: './feed.component.html',
  styleUrls: ['../userpanel.component.css'],
  providers: [FeedService, AuthService]
})

export class FeedComponent implements OnInit {


  @Input() client: string;

  public feedArray: any;

  public form: FormGroup;
  public formComment: FormGroup;
  public feed: Feed;
  public loggedInUser: any;
  public loaderActivated: any = false;
  public update = false;
  public empty = false;

  public loadingMore: boolean;

  public currentPage: number;
  public countPage: number;

  public uploadedFileType: string;
  public uploadedFileUrl: string;

  constructor(
    public fb: FormBuilder,
    private feedService: FeedService,
    private authService: AuthService,
    public dialog: MatDialog
  ) {
    this.buildForm();
    this.loaderActivated = true;
    this.loadingMore = false;

    const _this = this;

    $(window).scroll(function () {
      if ($(window).scrollTop() + $(window).height() == $(document).height()) {
        if (_this.currentPage) {
          _this.loadMore();
        }
      }
    });

  }

  getUsuarioLogado(): any {
    const loggedUser = JSON.parse(sessionStorage.getItem('loggedUser'));

    this.loggedInUser = loggedUser.data;
  }

  showFilePicker() {
    const component = this;
    client.pick({
      fromSources: ['local_file_system', 'webcam', 'video'],
      uploadInBackground: false,
      accept: ['image/*', 'video/*'],
      maxFiles: 1,
      lang: 'pt'
    }).then(function (response) {
      component.uploadedFileUrl = response.filesUploaded['0'].url;
      component.uploadedFileType = component.getTypeByMimeType(response.filesUploaded['0'].mimetype);
      console.log(response);
    });
  }

  getTypeByMimeType(mime: string): string {
    const split = mime.split('/');
    return split[0];
  }

  resetFilePicker() {
    this.uploadedFileType = null;
    this.uploadedFileUrl = null;
  }

  ngOnInit() {

    this.getUsuarioLogado();

    this.getFeed();

    let _this = this;

    this.feedService.feedChannel
      .bind('my-event-' + this.client, function (result) {
        if (result.type === 'item') {
          _this.feedArray.unshift(result.data);
        }

        if (result.type === 'comments') {
            let item = _this.feedArray.find(function (item) {
                return item.id == result.target;
            });
            if (item) {
                item.comments.data.unshift(result.data);
            }
        }

        if (result.type === 'answer') {
          const feed = _this.feedArray.find(function (feed) {
            return feed.id === result.data.item_feed
          })

          const item = feed.comments.data.find(function (item) {
            return item.id === result.data.comment_feed_id
          })

          if (item) {
            item.answer.data.unshift(result.data);
          }

        }

        if (result.type === 'updatePost') {
          console.log(_this.feedArray)
          let item = _this.feedArray.find(function (item) {
            return item.id === result.data.id;
          });
          if (item) {
            item.text = result.data.text;
            item.embed = result.data.embed;
            item.embedTipo = result.data.embedTipo;
            item.image = result.data.image;
          }
        }
        console.log(result)
      });
  }

  getFeed() {
    this.feedArray = [];
    this.feedService.getFeed(1)
      .subscribe(result => {
        console.log(result)
        this.feedArray = result.data;
        this.currentPage = result.meta.pagination.current_page;
        this.countPage = result.meta.pagination.total_pages;
        this.loaderActivated = false;
      });
  }

  buildForm(): void {
    this.form = this.fb.group({
      texto: ['', Validators.minLength(5)],
    });
    this.formComment = this.fb.group({
      comment: ['', Validators.minLength(5)],
    });
  }

  onSubmit(): any {
    this.empty = false;
    this.feedService.publishNewPost(this.preparePostItem())
      .subscribe(res => {
        // this.getFeed();
      });
    this.form.reset();
  }

  onSubmitComment(id: number): any {
    this.feedService.publishNewComment(this.prepareComment(id))
      .subscribe(res => {
        // this.getFeed();
      });
    this.formComment.reset();
  }

  OnUpdateComment(id: number): void {
    this.feedService.updateComment(this.prepareComment(id))
    .subscribe(res => {
      // this.getFeed();
      console.log(res)
    });
    this.update = false;
  }

  deleteFeed(id) {
    Swal.fire({
      title: 'Você quer apagar o item?',
      text: 'Você não poderá reverter essa ação depois de confirmado',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then(
      (result) => {
        if (result.value) {
          this.feedService.deleteFeed(id).subscribe(
            res => {
              for (let i = 0; i < this.feedArray.length; i++) {
                if (this.feedArray[i].id === id) {
                  this.feedArray.splice(i, 1);
                  break;
                }
              }
            }
          )                    
        }

      },
      (cancel) => {}
    );
  }

  deleteComment(id) {
    Swal.fire({
      title: 'Você quer apagar o item?',
      text: 'Você não poderá reverter essa ação depois de confirmado',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then(
      (result) => {
        if (result.value) {
          this.feedService.deleteComment(id).subscribe(
            res => {
            }
          )                    
        }

      },
      (cancel) => {}
    );
  }

  preparePostItem(): Feed {
    const formModel = this.form.value;
    const feed = new Feed();

    let embed;
    embed = this.checkIfHasEmbededVideo(formModel.texto);
    // @TODO: Resolver problema de pasta forçada

    feed.titulo = formModel.texto;
    feed.texto = formModel.texto;
    feed.author = this.loggedInUser.name;
    feed.pasta_id = 1;

    if (typeof embed === 'object') {
      feed.embed = embed.url;
      feed.texto = '';
      feed.titulo = 'Embed';
    } else {
      feed.embed = '';
    }

    if (this.uploadedFileUrl && this.uploadedFileType === 'video') {
      feed.embedTipo = 'file';
      feed.embed = this.uploadedFileUrl;
    }

    if (this.uploadedFileUrl && this.uploadedFileType === 'image') {
      feed.image = this.uploadedFileUrl;
    }

    this.resetFilePicker();

    if (feed.texto === '' && feed.embed === '' && feed.image === '') {
      this.empty = true
    } else {
      return feed;
    }
  }

  prepareComment(id: number): Comment {
    const formModel = this.formComment.value;
    const obj = new Comment();
    obj.comment = formModel.comment;
    obj.feed_itens_id = id;
    return obj;
  }

  checkIfHasEmbededVideo(value: string): any {
    if (value.includes('vimeo')) {
      return {url: '//player.vimeo.com/video/' + value.split('/')[4]};
    } else if (value.includes('youtube')) {
      return {url: '//www.youtube.com/embed/' + value.split('=')[1]};
    } else {
      return value;
    }
  }

  loadMore() {

    if (this.currentPage < this.countPage) {
      this.loadingMore = true;

      const nextPage = this.currentPage + 1;

      this.feedService.getFeed(nextPage)
        .subscribe(result => {
          this.feedArray.push(...result.data);
          this.currentPage = result.meta.pagination.current_page;
          this.countPage = result.meta.pagination.total_pages;
          this.loadingMore = false;
        });

    }

  }

  like(item: any) {
    if (item.isLike === 1) {
      item.isLike = 0;
      item.Likes--;
    } else {
      item.isLike = 1;
      item.Likes++;
    }

    this.feedService.like(item.id).subscribe(res => {
      console.log(res);
    });
  }

  ExpandImg(image) {
    const dialogRef = this.dialog.open(ModalFeedComponent, {
      panelClass: 'full-screen-dialog',
      data: { img: image }
    });
  }

  openUpdateModal(item) {
    const dialogRef = this.dialog.open(ModalContentComponent, {
      width: '650px',
      maxHeight: '80%',
      data: item
    });

    dialogRef.afterClosed().subscribe(result => {
      // trocar pelo pusher
      if (result) {
        // this.getFeed();
      }
    });
  }

  /*update(id) {
    console.log(id)
  }*/


  shared() {
    console.log('compartilhar')
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/feed/feed.component.ts